
import { AlertTriangle } from 'lucide-react';
import Modal from '../../../../components/base/Modal';
import Button from '../../../../components/base/Button';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  gameName: string;
}

export default function DeleteConfirmModal({ isOpen, onClose, onConfirm, gameName }: DeleteConfirmModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="ゲームの削除"
      size="sm"
    >
      <div className="space-y-4">
        <div className="flex items-center space-x-3">
          <div className="flex-shrink-0">
            <AlertTriangle className="h-6 w-6 text-red-500" />
          </div>
          <div>
            <p className="text-sm text-gray-900">
              「<strong>{gameName}</strong>」を削除しますか？
            </p>
            <p className="text-sm text-gray-500 mt-1">
              この操作は取り消すことができません。
            </p>
          </div>
        </div>
        
        <div className="flex justify-end space-x-3 pt-4">
          <Button variant="ghost" onClick={onClose}>
            キャンセル
          </Button>
          <Button variant="danger" onClick={onConfirm}>
            削除する
          </Button>
        </div>
      </div>
    </Modal>
  );
}
